// Defense-in-depth guard for rendering a backend-provided URL as an
// <a href>: only allow http(s) absolute URLs or same-origin relative
// paths, rejecting javascript:/data:/vbscript:/etc. schemes from a
// compromised or malicious backend document. Not a full URL parser -
// deliberately conservative. Known, accepted limitation: this does not
// block protocol-relative "//evil.com" URLs from resolving to an
// attacker-controlled https origin - that's a cross-origin-content
// question already mitigated by target="_blank" rel="noopener
// noreferrer" wherever this is used, not a scheme-injection one.
const isSafeUrl = url => {
  if (typeof url !== "string" || !url) return false;
  const trimmed = url.trim();
  if (trimmed.startsWith("/") && !trimmed.startsWith("//")) return true;
  try {
    const parsed = new URL(trimmed, window.location.origin);
    return parsed.protocol === "http:" || parsed.protocol === "https:";
  } catch (e) {
    return false;
  }
};

export default isSafeUrl;
